<template>
  <span :class="decimales == '00' ? 'mr-4' : ''">
    {{ entero }}<sup v-if="decimales != '00'">{{ decimales }}</sup>
  </span>
</template>

<script>
import { format_money } from '../../util/utils'

export default {
  props: {
    value: Number
  },
  computed: {
    entero: {
      get () {
        return format_money(this.value).split(',')[0]
      }
    },
    decimales: {
      get () {
        return format_money(this.value).split(',')[1]
      }
    }
  }
}
</script>